import fetchClient from "../utils/http-common";
import { SERVER_API_URL } from '../config/Constants'

const getUser = (id, onUploadProgress = (event) => {
  //setProgress(Math.round((100 * event.loaded) / event.total));
  }) => {


  return fetchClient.get(`${SERVER_API_URL}/users/${id}.json`, {
    onUploadProgress,
  });
};


const getFriends = () => {
  return fetchClient.get(`${SERVER_API_URL}/users/my_friends.json`);
};

const getPendingFriends = () => {
  return fetchClient.get(`${SERVER_API_URL}/friends/pending.json`);
};

const getFriendshipStatus = (friendId) => {
  return fetchClient.get(`${SERVER_API_URL}/friends/status/${friendId}.json`);
};

const requestFriend = (friendId) => {
  return fetchClient.post(`${SERVER_API_URL}/friends/request_friend.json`, { friend_id: friendId });
};

const acceptFriend = (friendId) => {
  return fetchClient.post(`${SERVER_API_URL}/friends/accept.json`, { friend_id: friendId });
};

const denyFriend = (friendId) => {
  return fetchClient.post(`${SERVER_API_URL}/friends/deny.json`, { friend_id: friendId });
};

export default {
  getUser,
  getFriends,
  getPendingFriends,
  getFriendshipStatus,
  requestFriend,
  acceptFriend,
  denyFriend
};
